// Auto-generated imports for project sources
import "./web/app/app.css";
export * from "./web/app/navbar";
export * from "./web/app/tailwind.config";

